<template>
  <component
    :is="tag"

    class="main-button"
    :class="[
      getTypeClass,
      {'main-button-style': !disableStyle},
      {'w100': w100},
      {'r100': r100},
      {'disabled': disabled},
      {'is-loading': isLoading},
    ]"

    :disabled="disabled"

    @click="onClick"
  >
    <div
      v-if="isLoading"
      class="main-button__is-loading"
    >
      <Loader />
    </div>
    <div class="main-button__content-before">
      <slot name="before" />
    </div>
    <div class="main-button__main-content">
      <slot>
        <img
          v-if="type === 'google'"
          :src="require(`@/assets/images/payments/googlepay-logo-full.svg`)"
          alt="googlepay"
        >
        <img
          v-else-if="type === 'apple'"
          :src="require(`@/assets/images/payments/apple-pay.svg`)"
          alt="applelepay"
        >
      </slot>
    </div>
    <div class="main-button__content-after">
      <slot name="after" />
    </div>
  </component>
</template>

<script>
/**
 * @description Стили для компонента находятся в _c-btn.scss
 */

import Loader from '@/components/core/ui/Loader'

export default {
  name: 'CBtn',

  components: {
    Loader,
  },

  props: {
    /**
     * @description Отключение стилей кнопки
     */
    disableStyle: {
      type: Boolean,
      default: false,
    },

    /**
     * @description Тип тега
     */
    tag: {
      type: String,
      default: 'button',
    },

    /**
     * @description Расширяет кнопку на 100%
     */
    w100: {
      type: Boolean,
      default: true,
    },

    /**
     * @description Скругление радиуса кнопки
     */
    r100: {
      type: Boolean,
      default: false,
    },

    /**
     * @description Отключает кнопку
     */
    disabled: {
      type: Boolean,
      default: false,
    },

    /**
     * @description Показывает тогл загрузки
     */
    isLoading: {
      type: Boolean,
      default: false,
    },

    /**
     * @description Тип кнопки, добавляет к корневому элементу класс main-button__${type}
     */
    type: {
      type: String,
      default: null,
    },
  },

  emits: ['click'],

  computed: {
    getTypeClass () {
      if (this.type && !this.disableStyle && !this.disabled) {
        return `main-button__${this.type}`
      }
      return null
    },
  },

  methods: {
    onClick () {
      this.$emit('click', true)
    },
  },
}
</script>
